import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Camera: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    fill="none"
    {...props}
  >
    <path
      d="M12 32C12 34.2 13.8 36 16 36C18.2 36 20 34.2 20 32V24H28C30.2 24 32 22.2 32 20C32 17.8 30.2 16 28 16H20V8C20 5.8 18.2 4 16 4C13.8 4 12 5.8 12 8V16H4C1.8 16 0 17.8 0 20C0 22.2 1.8 24 4 24H12V32Z"
      fill="#002677"
    />
    <path
      d="M52 68C58.6274 68 64 62.6274 64 56C64 49.3726 58.6274 44 52 44C45.3726 44 40 49.3726 40 56C40 62.6274 45.3726 68 52 68Z"
      fill="#002677"
    />
    <path
      d="M84 24H71.32L66.36 18.6C64.88 16.96 62.72 16 60.48 16H34.88C35.56 17.2 36 18.52 36 20C36 24.4 32.4 28 28 28H24V32C24 36.4 20.4 40 16 40C14.52 40 13.2 39.56 12 38.88V80C12 84.4 15.6 88 20 88H84C88.4 88 92 84.4 92 80V32C92 27.6 88.4 24 84 24ZM52 76C40.96 76 32 67.04 32 56C32 44.96 40.96 36 52 36C63.04 36 72 44.96 72 56C72 67.04 63.04 76 52 76Z"
      fill="#002677"
    />
  </Box>
)
export default Camera
